module.exports = __webpack_public_path__ + "img/Bugzilla.f408a92.svg";